// externals
import type { RSAACallAction } from '@makemydeal/dr-react-18-wrappers';
import { RSAA } from 'redux-api-middleware';

// libraries
import { paymentPayloadUtils } from '@makemydeal/dr-offer-redux';

// actions
import {
    PAYMENT_FEES_TYPES_FAILURE,
    PAYMENT_FEES_TYPES_REQUEST,
    PAYMENT_FEES_TYPES_SUCCESS
} from '../actionTypes/offerActionTypes';

// utils
import { getCurrentOfferType, getSelectedTerm } from '../selectors/offerRedux';
import { getFeesTypesUrl } from '../utils/paymentServiceUtils';

// types
import type { StateTree } from '@makemydeal/dr-dash-types';
import type { Dispatch } from 'redux';
import { buildPaymentPayloadHostSelectors } from '../utils/offerPayloadUtil';
import { ApplicationCodes } from '@makemydeal/dr-platform-types';
import { TRACE_ID_HEADER } from '@makemydeal/dr-shared-bff-types';

export const getPaymentFeesTypes =
    (): any =>
    (dispatch: Dispatch<any, any>, getState: () => StateTree): void => {
        const state = getState();
        const currentOfferType = getCurrentOfferType(state);
        const currentSelectedProgram = getSelectedTerm(state, currentOfferType);
        const hostSelectors = buildPaymentPayloadHostSelectors();

        const payload = paymentPayloadUtils.createPaymentPayload(state, hostSelectors, {
            type: PAYMENT_FEES_TYPES_REQUEST,
            meta: { sourceApplication: ApplicationCodes.MV }
        });

        const endpoint = getFeesTypesUrl(state);

        dispatch<RSAACallAction>({
            [RSAA]: {
                endpoint,
                method: 'POST',
                body: JSON.stringify({
                    ...payload,
                    preferences: {
                        zipCode: payload.shopper?.zip ?? '',
                        dealerId: payload.dealerId
                    }
                }),
                headers: { 'Content-Type': 'application/json', [TRACE_ID_HEADER]: payload.traceId ?? '' },
                types: [
                    PAYMENT_FEES_TYPES_REQUEST,
                    {
                        type: PAYMENT_FEES_TYPES_SUCCESS,
                        meta: { currentOfferType, currentSelectedProgram }
                    },
                    PAYMENT_FEES_TYPES_FAILURE
                ]
            }
        });
    };
